<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资料管理</el-breadcrumb-item>
      <el-breadcrumb-item>列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 顶部筛选条件 -->
      <el-row :gutter="20" style="margin-bottom: 12px;">
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">年级：</span>
            <el-select v-model="queryInfo.grade_id" placeholder="选择年级" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option v-for="item in gradeOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">科目：</span>
            <el-select v-model="queryInfo.subject_id" placeholder="选择科目" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option v-for="item in subjectOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">类别：</span>
            <el-select v-model="queryInfo.category_id" placeholder="选择类别" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option v-for="item in categoryOptions" :key="item.id" :label="item.label" :value="item.id" />
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="filter-item">
            <span class="filter-label">上架：</span>
            <el-select v-model="queryInfo.status" placeholder="选择状态" clearable @change="handleFilterChange" style="flex: 1;">
              <el-option :label="'未上架'" :value="0" />
              <el-option :label="'已上架'" :value="1" />
            </el-select>
          </div>
        </el-col>
      </el-row>

      <!-- 搜索与新增 -->
      <el-row :gutter="24" style="margin-bottom: 8px;">
        <el-col :span="8">
          <el-input placeholder="请输入资料名称" v-model="queryInfo.query" clearable @clear="getList">
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </el-input>
        </el-col>
       
        <el-col :span="8" v-if="canLook == 1">
          <div class="excel-actions">
            <el-button type="primary" @click="goAddpage">添加资料</el-button>

            <el-upload
              class="upload-excel"
              :action="'#'"
              :show-file-list="false"
              accept=".xls,.xlsx"
              :before-upload="handleExcelUpload"
            >
              <el-button type="success">导入Excel</el-button>
            </el-upload>
            <el-button class="download-template-btn" type="primary" @click="downloadExcelTemplate">下载Excel模板</el-button>
          </div>
        </el-col>
      </el-row>

      <!-- table表格区域 -->
      <el-table :data="goodslist" border stripe class="compact-table" size="mini">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column label="id" prop="id" width="70"></el-table-column>
        <el-table-column label="名称" prop="name" width="220">
            <template slot-scope="scope">
                 <el-row :gutter="0" class="multiline-cell">
                   <el-col :span="24">{{ '名称：' + scope.row.name }}</el-col>
                    <el-col :span="24">{{ '年级：' + scope.row.grade_name }}</el-col>
              <el-col :span="24">{{ '学科：' + scope.row.subject_name }}</el-col>
               <el-col :span="24" class="status-row">{{ '上架状态：' }}
                <span class="status-badge off" v-if="scope.row.status == 0">未上架</span>
                <span class="status-badge on" v-if="scope.row.status == 1">已上架</span>
              </el-col>
                   <!-- <el-col :span="24">{{ '描述：' + scope.row.description }}</el-col> -->
                 </el-row>
            </template>
        </el-table-column>
        <!-- <el-table-column label="描述" prop="description" width="180px"></el-table-column> -->

        <el-table-column label="封面" width="110" align="center">
          <template slot-scope="scope">
            <el-image style="width: 80px; height: 80px" :src="scope.row.fengmian_url" fit="cover" :preview-src-list="[scope.row.fengmian_url]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="文件信息" align="center" width="150">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell"> 
              <el-col :span="24">{{ '类型：' + scope.row.category_name }}</el-col>
              <el-col :span="24">{{ '角标：' + scope.row.mark }}</el-col>
              <el-col :span="24">{{ '标识：' + scope.row.identification }}</el-col> 
            </el-row>
          </template>
        </el-table-column>

            <el-table-column label="文件信息" align="center" width="200">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell">
             
              <el-col :span="24">{{ '大小：' + scope.row.file_size  + '/总页数：' + scope.row.total_page}} </el-col>
              
              <el-col :span="24">{{ '下载链接：' + scope.row.download_url }}</el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="状态" v-if="canLook == 1" width="210">
          <template slot-scope="scope">
            <el-row :gutter="0" class="multiline-cell">
             
              <el-col :span="24">{{ '点击数：' + scope.row.click_count }}</el-col>
              <el-col :span="24">{{ '下载数：' + scope.row.download_count }}</el-col>
              <el-col :span="24">{{ '收藏数：' + scope.row.collection_count }}</el-col>
              <el-col :span="24">{{ '创建：' + scope.row.create_time }}</el-col>
              <el-col :span="24">{{ '更新：' + scope.row.update_time }}</el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="goEditPage(scope.row.id)"></el-button>
            <el-button type="warning" icon="el-icon-success" size="mini" @click="shangjia(scope.row.id)" v-if="scope.row.status == 0"></el-button>
            <el-button type="danger" icon="el-icon-error" size="mini" @click="xiajia(scope.row.id)" v-if="scope.row.status == 1"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[5, 10, 15, 20,50]" :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canLook: 1,
      // 查询参数对象
      queryInfo: {
        query: '',
        page: 1,
        page_size: 50,
        grade_id: null,
        subject_id: null,
        category_id: null,
        status: null
      },
      // 列表
      goodslist: [],
      // 总数据条数
      total: 0,
      // 顶部筛选选项
      gradeOptions: [],
      subjectOptions: [],
      categoryOptions: []
    }
  },

  created() {
    this.getList()
    this.getGradeList()
    this.getSubjectList()
    this.getCategoryList()
  },

  methods: {
    // 根据分页获取对应的商品列表
    async getList() {
      const { data: res } = await this.$http.get('admin/m/list', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取资料列表失败！')
      }
      this.$message.success('获取资料列表成功！')
      console.log(res.result)
      this.goodslist = res.result.items
      this.total = res.result.total

    },

    async downloadExcelTemplate() {
      try {
        const XLSX = (await import('xlsx')).default || (await import('xlsx'))
        const headers = [
          '文件名', '年级', '科目', '类别',
          '是否会员', '价格', '角标', '标识',
          '封面链接','下载链接', '文件大小', '文件类型',
          '总页数', '点击数', '下载数', '收藏数',
          '描述', '是否上架'
        ]
        // 仅导出表头，无示例数据行
        const aoa = [headers]
        const ws = XLSX.utils.aoa_to_sheet(aoa)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, '模板')
        XLSX.writeFile(wb, '资料导入模板.xlsx')
        this.$message.success('模板已下载')
      } catch (e) {
        console.error(e)
        this.$message.error('模板生成失败，请稍后重试')
      }
    },

    // 处理Excel上传（前端解析，不实际上传到服务器）
    async handleExcelUpload(file) {
      try {
        const XLSX = (await import('xlsx')).default || (await import('xlsx'))
        const data = await file.arrayBuffer()
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[sheetName]
        const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' })
        if (!rows || rows.length === 0) {
          this.$message.warning('表格为空或无法解析')
          return false
        }
        const summary = await this.importMaterialsFromRows(rows)
        this.$message.success(`导入完成：成功 ${summary.success} 条，失败 ${summary.failed} 条`)
        if (summary.failedDetails.length) {
          console.log('导入失败详情：', summary.failedDetails)
        }
        this.getList()
      } catch (e) {
        console.error(e)
        this.$message.error('解析Excel失败，请检查文件格式')
      }
      // 阻止 el-upload 继续上传
      return false
    },

    // 将Excel行映射为后端需要的字段并批量新增
    async importMaterialsFromRows(rows) {
      const success = 0
      const failed = 0
      const failedDetails = []
      let ok = 0, bad = 0
      // 构建名称到ID的映射，便于用名称填充ID
      const gradeMap = new Map(this.gradeOptions.map(o => [String(o.label).trim(), o.id]))
      const subjectMap = new Map(this.subjectOptions.map(o => [String(o.label).trim(), o.id]))
      const categoryMap = new Map(this.categoryOptions.map(o => [String(o.label).trim(), o.id]))

      for (const [idx, r] of rows.entries()) {
        try {
          const item = {
            name: r['文件名'] || r['name'] || '',
            grade_id: this.parseIdOrLookup(r['年级'] || r['grade'], gradeMap),
            subject_id: this.parseIdOrLookup(r['科目'] || r['subject'], subjectMap),
            category_id: this.parseIdOrLookup(r['类别'] || r['分类'] || r['category'], categoryMap),
            isVip: this.parseNumber(r['是否会员'] || r['isVip'], 0),
            price: this.parseNumber(r['价格'] || r['price'], 0),
            mark: r['角标'] || r['mark'] || '',
            identification: r['标识'] || r['identification'] || '',
            download_url: r['下载链接'] || r['download_url'] || '',
            file_size: r['文件大小'] || r['file_size'] || '',
            file_type: this.parseFileType(r['文件类型'] || r['file_type']),
            total_page: this.parseNumber(r['总页数'] || r['total_page'], 0),
            click_count: this.parseNumber(r['点击数'] || r['click_count'], 0),
            download_count: this.parseNumber(r['下载数'] || r['download_count'], 0),
            collection_count: this.parseNumber(r['收藏数'] || r['collection_count'], 0),
            description: r['描述'] || r['description'] || '',
            status: this.parseVisible(r['是否上架'] || r['上架状态'] || r['status'])
          }
          // 基础校验
          console.log(item)
          if (!item.name || !item.download_url || !item.file_size) {
            throw new Error('必填字段缺失（文件名/下载链接/文件大小）')
          }
          const { data: res } = await this.$http.post('admin/m/add', item)
          console.log(res)
          if (res.code !== 200) throw new Error(res.message || '添加失败')
          ok += 1
        } catch (err) {
          bad += 1
          failedDetails.push({ row: idx + 2, // +2：考虑表头从第1行
            error: err && err.message ? err.message : String(err) })
        }
      }
      return { success: ok, failed: bad, failedDetails }
    },

    parseIdOrLookup(val, map) {
      if (val === undefined || val === null) return null
      const s = String(val).trim()
      const num = Number(s)
      if (!isNaN(num) && num > 0) return num
      return map.get(s) || null
    },

    parseNumber(val, def = 0) {
      const n = Number(val)
      return isNaN(n) ? def : n
    },

    parseVisible(val) {
      const s = String(val).trim()
      if (s === '' || s === 'null' || s === 'undefined') return 0
      if (s === '已上架' || s === '上架' || s === '1') return 1
      if (s === '未上架' || s === '下架' || s === '0') return 0
      const n = Number(s)
      return isNaN(n) ? 1 : (n === 0 ? 0 : 1)
    },

    parseFileType(val) {
      const s = String(val).trim().toLowerCase()
      const map = { pdf: 0, word: 1, excel: 2, xls: 2, xlsx: 2, 图片: 3, image: 3, other: 4, 其他: 4 }
      if (s === '' || s === 'null' || s === 'undefined') return 0
      if (!isNaN(Number(s))) return Number(s)
      return map[s] !== undefined ? map[s] : 0
    },

    // 年级列表（仅获取上架/有效的）
    async getGradeList() {
      const { data: res } = await this.$http.get('admin/g/activeList', {})
      if (res.code !== 200) {
        return this.$message.error('获取年级列表失败！')
      }
      this.gradeOptions = (res.result || []).map(item => ({ id: item.id, label: item.name }))
    },

    // 科目列表（仅获取上架/有效的）
    async getSubjectList() {
      const { data: res } = await this.$http.get('admin/s/activeList', {})
      if (res.code !== 200) {
        return this.$message.error('获取科目列表失败！')
      }
      this.subjectOptions = (res.result || []).map(item => ({ id: item.id, label: item.name }))
    },

    // 类别列表（仅获取上架/有效的）
    async getCategoryList() {
      const { data: res } = await this.$http.get('admin/c/activeList', {})
      if (res.code !== 200) {
        return this.$message.error('获取类别列表失败！')
      }
      this.categoryOptions = (res.result || []).map(item => ({ id: item.id, label: item.name }))
    },

    // 任一筛选条件改变
    handleFilterChange() {
      this.queryInfo.page = 1
      this.getList()
    },

    handleSizeChange(newSize) {
      this.queryInfo.page_size = newSize
      this.getList()
    },

    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getList()
    },

    //下架商品
    async xiajia(id) {
      const confirmResult = await this.$confirm(
        '此操作将下架该资料, 是否继续?',
        '提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消下架！')
      }
      const { data: res } = await this.$http.post('/admin/m/changeStatus', { id: id, status: 0 })
      if (res.code !== 200) {

        return this.$message.error('下架失败1！')
      }
      this.$message.success('下架成功1！')
      this.getList()
    },

    // 监听 switch 开关状态的改变
    async shangjia(id) {
      const { data: res } = await this.$http.post('/admin/m/changeStatus', {
        id: id,
        status: 1
      })
      if (res.code !== 200) {
        return this.$message.error('上架失败！')
      }
      this.$message.success('上架成功！')
      this.getList()
    },

    goAddpage() {
      this.$router.push('/goods/ziliaoAdd')
    },

    // 编辑页面跳转
    goEditPage(id) {
      this.$router.push({ path: '/goods/ziliaoAdd', query: { id: id } })
    }
  }
}
</script>

<style lang="less" scoped>
.tip {
  font-size: 13px;
  color: #cccccc;
}

.multiline-cell {
  white-space: normal;
  word-break: break-word;
  line-height: 20px;
}

.compact-table {
  font-size: 13px;
}

.compact-table .el-table__cell {
  padding: 8px 10px;
}

.compact-table .el-table__row {
  height: auto;
}

.status-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-badge {
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.status-badge.off {
  background: #f56c6c;
}

.status-badge.on {
  background: #67c23a;
}

/* 顶部筛选项布局 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-label {
  color: #606266;
  white-space: nowrap;
}

/* 导入与模板按钮左右分布 */
.excel-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.download-template-btn {
  margin-left: 8px;
}
</style>
